import zustand from "zustand";
import {devtools, persist} from "zustand/middleware";
import * as lodash from "lodash";

export type SettingsStoreProps = {
  [key: string]: Record<string, any> | string | number | null | undefined;
  setConfig: (key: string, value: any) => void;
  getConfig: (key: string) => any;

  MUI: Record<string, any>;
  setMUISettings: (key: string, field: string, values: any) => void;
  getMUISettings: (key: string) => any;

  tabs: Record<string, string>;
  setPersistedTab: (key: string, value: string) => void;
  getPersistedTab: (key: string | undefined) => string | null;

  navGroups: Record<string, boolean>;
  prevNavGroups: Record<string, boolean>;
  setNavGroup: (group: string, display: boolean, log?: boolean) => void;
  getNavGroup: (group: string) => boolean;
  getPrevNavGroup: (group: string) => boolean;
  setAllNavGroups: (state: boolean, log?: boolean) => void;
};
export const useConfigStore = zustand<SettingsStoreProps>()(
  devtools(
    persist(
      (set, get) => ({
        default_listSize: 100,
        setConfig: (key: string, value: any) => {
          set((old) => {
            const newConfig = lodash.clone(old);
            lodash.set(newConfig, key?.split("."), value);

            return {...newConfig};
          });
        },
        getConfig: (key: string) => {
          const values = get();
          return lodash.get(values, key?.split(".")) || null;
        },

        tabs: {},
        setPersistedTab: (key: string, value: string) => {
          set((old) => ({
            ...old,
            tabs: {
              ...old.tabs,
              [key]: value,
            },
          }));
        },
        getPersistedTab: (key: string | undefined) => {
          if (key) {
            const values = get();
            return lodash.get(values, ["tabs", key]);
          } else {
            return null;
          }
        },

        MUI: {},
        setMUISettings: (key: string, field: string, values: any) => {
          set((old) => ({
            ...old,
            MUI: {
              [key]: {
                [field]: values,
              },
            },
          }));
        },
        getMUISettings: (key: string) => {
          const values = get().MUI;
          return lodash.get(values, key?.split("."));
        },

        navGroups: {},
        prevNavGroups: {},
        setNavGroup: (group, display, log) => {
          set((old) => {
            const temp = lodash.clone(old);

            lodash.set(temp, ["navGroups", group], display);

            return {...temp};
          });
        },
        getNavGroup: (group) => {
          const values = get().navGroups;

          return lodash.get(values, group, false);
        },
        getPrevNavGroup: (group) => {
          const values = get().prevNavGroups;

          return lodash.get(values, group, false);
        },
        setAllNavGroups: (state, log) => {
          set((old) => {
            const temp = lodash.clone(old);

            if (log) {
              lodash.set(temp, "prevNavGroups", lodash.clone(old.navGroups));
            }

            Object.keys(old.navGroups).forEach((group) => {
              lodash.set(temp, ["navGroups", group], state);
            });

            return {...temp};
          });
        },
      }),
      {
        name: "config-store",
      }
    )
  )
);
